import { jsx as l } from "@emotion/react/jsx-runtime";
import { aC as I, a as y, e as i, b5 as p } from "./StickyHeaderSkeleton-f12bcf9d.mjs";
import { u as E, W as T, t as f, c as G, f as L, d as R, h as S, j as v, g as C, x as w } from "./Header-490425af.mjs";
import { useDisclosure as W } from "@mantine/hooks";
import { useEffect as g } from "react";
import { u as A } from "./useMyCourseCategoryQuery-f4115ed6.mjs";
import "@emotion/react";
import "@inflearn/ds-react";
import "@mantine/core";
import "react/jsx-runtime";
import "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/ko";
import "dayjs/plugin/localizedFormat";
import "dayjs/plugin/updateLocale";
import "@inflearn/datasource-rest";
import "@tanstack/react-query";
import "@inflearn/analytics";
import "./LoginModal-65bd91c4.mjs";
import "react-hook-form";
import "dayjs/plugin/duration";
import "dayjs/plugin/relativeTime";
import "@hackler/react-sdk";
import "react-error-boundary";
function ro() {
  const {
    data: o
  } = E(), {
    isCached: e
  } = T(o == null ? void 0 : o.id), a = f((o == null ? void 0 : o.id) || 0);
  return !(o != null && o.id) || e || a ? null : /* @__PURE__ */ l(D, {});
}
function D() {
  const {
    lang: o
  } = I(), {
    trackEvent: e
  } = y(), [a, m] = W(), [, M] = G(v.MY_CATEGORY), {
    data: t
  } = E(), {
    data: r
  } = A(), {
    isShowGroupNotice: c,
    isLoadingForGroupNotice: u
  } = L(), {
    setCache: h
  } = T(t == null ? void 0 : t.id), s = R({
    enabled: a,
    valueKey: C.FIRST_HELLO,
    onSuccessPipe: (n) => (n.set(w.TO, C.IS_FIRSTREGISTER), n)
  }), N = () => {
    const n = s ? i.CLICK_WELCOME_BUTTON : i.CLICK_MYCATEGORY_GUIDE_BUTTON;
    m.close(), M.open(), e(n);
  }, d = !!r && r.length !== 0;
  g(() => {
    if (!(c || u) && r) {
      if (d) {
        h();
        return;
      }
      m.open();
    }
  }, [c, u, d, r]), g(() => {
    s && (e(i.COMPLETE_SIGNUP), e(i.COMPLETE_REGISTRATION));
  }, [s]);
  const O = a && !!(t != null && t.id), _ = s ? `${p}/image/apng/hugging-face.png` : `${p}/image/apng/heart-with-arrow.png`;
  return /* @__PURE__ */ l(S, { isOpened: O, lang: o, onClose: N, userName: (t == null ? void 0 : t.name) || "", animationUrl: _, withConfetti: s });
}
export {
  ro as default
};
